<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
  
  

  <b-card title="Billing">
    <template v-if="$user.main_account==true && $active_account==null">
      <template v-for="sub_account,index in $user.sub_accounts" >
      <center >
        <h1>Account:{{ sub_account.brand_name?sub_account.brand_name:sub_account.name }}</h1>
      </center>
      <template v-if="subscribed[index]">
        <b-card>
          <b-row>
            <b-col cols="3">
              Your subscription
              <div class="grey-color">Manage your plan & billing</div>
            </b-col>
            <b-col cols="9">
              <b-card class="border">
                <div class="plan-header">
                  <div>Your plan</div>
                  <div>
                    <b-button
                    @click="$router.push('/subscription')"
                      variant="secondary"
                      class="ml-2"
                    >
                      Manage plan
                    </b-button>
                  </div>
                </div>
                <div class="sub-left">
                  <img src="@/assets/images/check.svg" alt="Scan" />
                  <span>{{ current_subscription[index].subscription_type.name }}</span>
                </div>
                <div class="sub-left">
                  <img src="@/assets/images/check.svg" alt="Scan" />
                  <span>{{ current_subscription[index].subscription_type.price }}€ / month</span>
                </div>
              </b-card>
            </b-col>
          </b-row>
          

    <b-row>
      <b-col cols="3">
        Card details
       
        <div class="grey-color"> Select default payment method</div>
        <br /> 
        <b-button
              @click="displayCardModal(current_subscription[index].customer_stripe_id,index)"
                variant="primary"
              >Edit card</b-button>
      </b-col>
      <b-col cols="9">
        <b-card class="border" v-for="payment_method in payment_methods[index]" :key="payment_method.id">
          <div class="plan-header">
            <div class="title-card">
              <div class="card-icon">
              <img v-if="payment_method.card.brand=='mastercard'" class="img-fluid" src="@/assets/images/mastercard.png" alt="Master Card">
            <img v-else-if="payment_method.card.brand=='visa'" class="img-fluid" src="@/assets/images/visa.png" alt="Visa Card">
            <img v-else-if="payment_method.card.brand=='american_express'" class="img-fluid" src="@/assets/images/american-express.png" alt="American Express Card">
            <img v-else class="img-fluid" src="@/assets/images/logo-cb.jpg" alt="CB">
              </div>
              <span>
                {{payment_method.card.brand.charAt(0).toUpperCase() + payment_method.card.brand.slice(1)}}
                <br />
                ∗∗∗∗ ∗∗∗∗ ∗∗∗∗ {{payment_method.card.last4}}<br />
                <span class="grey-color">Expiry on {{payment_method.card.exp_month}}/{{payment_method.card.exp_year}}<br />
                  {{payment_method.billing_details.name}}
                </span>

                              </span>
                            </div>
                      
                          </div>
                      
                        </b-card>
                    
                      </b-col>
                    </b-row>
                    <br /> 
                    <b-row>
                      <div class="col-md-12">
                        Invoices
                      
                      
                      <div class="grey-color">Manage your billing history</div>

                      <table class="table table-bordered">
                    
                    <tr>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                
                
                <tbody>


                  <tr v-for="invoice in invoices[index]" :key="invoice.id">
                    <td>{{ formatDate(invoice.effective_at) }}</td>
                    <td>{{ invoice.amount_due / 100 }}€</td>
                    <td>{{ invoice.status }}</td>
                    <td><b-button variant="info" :href="invoice.invoice_pdf">Download</b-button></td>
                  </tr>
                </tbody>
                </table>
                </div>
                    </b-row>
        </b-card>
    </template>
    <template v-else>
     You have no subscription for this account.
    </template>
    </template>
    </template>
    <template v-else>
    <template v-if="$user.is_demo==true">
      <br />
      Your account is on demo mode.
    </template>
    <template v-if="subscribed">
      <br />
      <b-row>
      <b-col cols="3">
        Your subscription
        <div class="grey-color">Manage your plan & billing</div>
      </b-col>
      <b-col cols="9">
        <b-card class="border">
          <div class="plan-header">
          <div>Your plan</div>
          <div>
        
              <b-button
              @click="$router.push('/subscription')"
                variant="secondary"
                class="ml-2"
              >
                Manage plan
              </b-button>
            </div>
          </div>
          <div class="sub-left">
            <img src="@/assets/images/check.svg" alt="Scan" />
            <span>{{ current_subscription.subscription_type.name }}</span>
          </div>
          <div class="sub-left">
            <img src="@/assets/images/check.svg" alt="Scan" />
            <span>{{ current_subscription.subscription_type.price }}€ / month</span>
          </div>
        </b-card>
    
      </b-col>
    </b-row>


    <b-row>
      <b-col cols="3">
        Card details
       
        <div class="grey-color"> Select default payment method</div>
<br /> 
        <b-button
              @click="displayCardModal(current_subscription.customer_stripe_id,null)"
                variant="primary"
              >Edit card</b-button>
      </b-col>
      <b-col cols="9">
        <b-card class="border" v-for="payment_method in payment_methods" :key="payment_method.id">
          <div class="plan-header">
            <div class="title-card">
              <div class="card-icon">
              <img v-if="payment_method.card.brand=='mastercard'" class="img-fluid" src="@/assets/images/mastercard.png" alt="Master Card">
            <img v-else-if="payment_method.card.brand=='visa'" class="img-fluid" src="@/assets/images/visa.png" alt="Visa Card">
            <img v-else-if="payment_method.card.brand=='american_express'" class="img-fluid" src="@/assets/images/american-express.png" alt="American Express Card">
            <img v-else class="img-fluid" src="@/assets/images/logo-cb.jpg" alt="CB">
              </div>
              <span>
                {{payment_method.card.brand.charAt(0).toUpperCase() + payment_method.card.brand.slice(1)}}
<br />
∗∗∗∗ ∗∗∗∗ ∗∗∗∗ {{payment_method.card.last4}}<br />
<span class="grey-color">Expiry on {{payment_method.card.exp_month}}/{{payment_method.card.exp_year}}<br />
  {{payment_method.billing_details.name}}
</span>

              </span>
            </div>
       
          </div>
       
        </b-card>
    
      </b-col>
    </b-row>
    <br /> 
    <b-row>
      <div class="col-md-12">
        Invoices
       
       
       <div class="grey-color">Manage your billing history</div>

      <table class="table table-bordered">
     
     <tr>
       <th>Date</th>
       <th>Montant</th>
       <th>Status</th>
       <th>Action</th>
     </tr>
 
 
 <tbody>


   <tr v-for="invoice in invoices" :key="invoice.id">
     <td>{{ formatDate(invoice.effective_at) }}</td>
     <td>{{ invoice.amount_due / 100 }}€</td>
     <td>{{ invoice.status }}</td>
     <td><b-button variant="info" :href="invoice.invoice_pdf">Download</b-button></td>
   </tr>
 </tbody>
 </table>
</div>
    </b-row>
    
  </template>
  <template v-else>
    You have no subscription for this account.
  </template>
</template>
  </b-card>
 


   
    <b-modal
          id="modal-change"
          cancel-variant="secondary"
          cancel-title="No"
          ok-variant="danger"
          ok-title="Yes"
          @ok="changeSubscription()"
          modal-class="modal-danger"
          centered
          title="Are you sure ?"
        >
          <b-card-text>
            Attention, this action is irreversible ! Are you sure you want to change your subscription ?
          </b-card-text>
        </b-modal>
    <b-modal
          id="modal-danger"
          cancel-variant="secondary"
          cancel-title="No"
          ok-variant="danger"
          ok-title="Yes"
          @ok="deleteSubscription()"
          modal-class="modal-danger"
          centered
          title="Are you sure ?"
        >
          <b-card-text>
            Attention, this action is irreversible ! Are you sure you want to delete this subscription ?
          </b-card-text>
        </b-modal>
        <b-modal
          id="modal-cb"
          cancel-variant="secondary"
          cancel-title="Cancel"
          ok-variant="primary"
          ok-title="Edit"
          @ok="editPaymentMethod"
         
                                 
          centered
          title="Edit payment method"
        >
        <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
            <b-card-text>
              <div id="payment-element"></div>
            </b-card-text>
          </b-overlay>
        </b-modal>
  </b-overlay>
</template>

<script>
import {BModal, BButton, BOverlay, BRow, BCol, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BModal,
    BButton,
    BRow,
    BCol
  },
  data() {
    return {
      current_subscription: null,
      displayChangeSub:false,
      subscriptions:[],
      currentChangeChoice:null,
      pageLength: 3,
      subscribed:false,
      totalRows:0,
      index:null,
      customer_stripe_id:null,
      subscription:null,
      currentPage:1,
      invoices:null,
      dir: false,
      payment_methods:null,
      loading:true,
      stripe:null,
      client_secret:null,
      selectedItem:null,
      columns: [
        {
          label: 'Code',
          field: 'code',
        },
        {
          label: 'Nom',
          field: 'name',
        },
        {
          label: 'Montant',
          field: 'amount',
        },
        {
          label: 'Action',
          field: 'action',
        }
        
      ],
      rows: [],
      searchTerm: '',
      cardElement:null,

    }
  },
  computed: {
    activeAccount() {
      return this.$active_account
    },
  },
  watch: {
    activeAccount() {
      this.loadBillingData()
    },
  },
  methods: {
    async loadBillingData() {
      this.loading = true

      if (this.$user.main_account == true && this.$active_account == null) {
        let current_subscription = []
        let invoices_arr = []
        let payment_methods_arr = []
        let subscribed = []
        for (let i = 0; i < this.$user.sub_accounts.length; i++) {
          let subscription = await APIRequest.list_with_request('subscriptions', '?user=' + this.$user.sub_accounts[i].id + '&status=active&order=desc')
          if (subscription[0].length > 0) {
            subscribed.push(true)
            current_subscription.push(subscription[0][0])
            let payment_methods = await APIRequest.get_request('get-payment-method/' + subscription[0][0].stripe_id, '')
            payment_methods_arr.push([payment_methods.data.data])
            let invoices = await APIRequest.get_request('get-invoices/' + subscription[0][0].customer_stripe_id, '')
            invoices_arr.push(invoices.data.data)
          }
        }
        this.current_subscription = current_subscription
        this.payment_methods = payment_methods_arr
        this.subscribed = subscribed
        this.invoices = invoices_arr
        let subscriptions = await APIRequest.list('subscription-types')
        this.subscriptions = subscriptions[0]
      } else {
        let user_id
        if (this.$active_account == null) {
          user_id = localStorage.id_user_senseye_auth
        } else {
          user_id = this.$active_account.id
        }
        let subscription = await APIRequest.list_with_request('subscriptions', '?user=' + user_id + '&status=active&order=desc')
        if (subscription[0].length > 0) {
          this.subscribed = true
          this.current_subscription = subscription[0][0]
          let payment_methods = await APIRequest.get_request('get-payment-method/' + this.current_subscription.stripe_id, '')

          this.payment_methods = [payment_methods.data.data]

          let invoices = await APIRequest.get_request('get-invoices/' + this.current_subscription.customer_stripe_id, '')
          this.invoices = invoices.data.data

          let subscriptions = await APIRequest.list('subscription-types')
          this.subscriptions = subscriptions[0]
          this.totalRows = subscriptions[1]
        } else {
          this.subscribed = false
          this.current_subscription = null
          this.payment_methods = null
          this.invoices = null
          let subscriptions = await APIRequest.list('subscription-types')
          this.subscriptions = subscriptions[0]
          this.totalRows = subscriptions[1]
        }
      }
      this.loading = false
    },
    formatDate(timestamp){
      let date = new Date(timestamp * 1000); // conversion en millisecondes

      let jour = String(date.getDate()).padStart(2, '0');
      let mois = String(date.getMonth() + 1).padStart(2, '0'); // mois de 0 à 11
      let annee = date.getFullYear();

      let dateFormatee = `${jour}/${mois}/${annee}`;
      return dateFormatee
    },
    formatDate2(timestamp){
      let date = new Date(timestamp).toLocaleDateString('fr-FR'); // conversion en millisecondes

      return date
    },
    async displayCardModal( customer_stripe_id,index ){

      this.index=index
      this.customer_stripe_id=customer_stripe_id
      this.$bvModal.show('modal-cb')

      let client_secret=await APIRequest.get_request('create-setup-intent/'+customer_stripe_id, '')

      this.stripe = Stripe('pk_test_51Ix7q2BGInQvVcEzPCh5bh4SVvsT3uAMwIB9bMqdesgZyQnsDeyAkFuVukFRiKKAELjWRkj8HRqKTwo9CnNTGoUI001k8WNdy2');
      this.client_secret=client_secret.data.client_secret
     
      const elements = this.stripe.elements();
      this.cardElement = elements.create("card");
      this.cardElement.mount("#payment-element");
      
    },
    async changeSubscription()
    {
      this.loading=true
      let update=await APIRequest.get_request('change-plan/'+this.current_subscription.stripe_id+'/'+this.currentChangeChoice+'/'+this.current_subscription.id, '')
    
      if(update.data.status=="success")
      {

      let subscription=await APIRequest.list_with_request('subscriptions', '?user='+localStorage.id_user_senseye_auth+'&status=active&order=desc')
      if(subscription[0].length>0)
      {
    
      this.current_subscription=subscription[0][0]

      }
      this.displayChangeSub=false

      this.loading=false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'L\'abonnement a été modifié !',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    }
    else
    {
      this.loading=false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Une erreur est survenue.',
          icon: 'AlertCircleIcon',
          variant: 'warning',
        },
      })
    }
    },
    async editPaymentMethod(bvModalEvent){
      this.loading = true
      bvModalEvent.preventDefault()

      const { setupIntent, error } = await this.stripe.confirmCardSetup(
        this.client_secret,
        {
          payment_method: {
            card: this.cardElement,
          },
        }
      )

      if (error) {
        alert(error.message)
        this.loading = false
        return
      }

      const isMainAccount = this.$user.main_account === true && this.$active_account == null && this.index !== null
      const stripeId = isMainAccount
        ? this.current_subscription[this.index].stripe_id
        : this.current_subscription.stripe_id

      let update = await APIRequest.get_request('update-payment-method/' + this.customer_stripe_id + '/' + setupIntent.payment_method, '')

      if (update.data.status == 'success') {
        let payment_methods = await APIRequest.get_request('get-payment-method/' + stripeId, '')

        if (isMainAccount) {
          this.$set(this.payment_methods, this.index, [payment_methods.data.data])
        } else {
          this.payment_methods = [payment_methods.data.data]
        }

        this.$bvModal.hide('modal-cb')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Méthode de paiement mise à jour !',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.loading = false
      } else {
        this.loading = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
      }
    },
    async deleteSubscription()
    {
      this.loading=true
      try {
        await APIRequest.delete('subscriptions',this.current_subscription.id)
        let subscriptions=await APIRequest.list('subscription-types')
        this.subscriptions=subscriptions[0]
        this.loading=false
        this.subscribed=false
        this.current_subscription=null
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'L\'abonnement a été supprimé !',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        
      } catch (error) {
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
      
    }
  },
  async mounted() {
    await this.loadBillingData()
  }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-good-table.scss';

.plan-header
{
  display:flex;
  justify-content: space-between;
  align-items: flex-start;
}
.plan-col
{
  padding:20px;
  background:#f1f1f1;
  border-radius:5px;
 
}
.subscription-price
{
  color:#999;
  font-size:22px;
}
.subscription-price .amount-sub
{
  color:#000;
  font-size:40px;
}
.subscription-card .btn
{
  width:100%;
}
.subscription-row {
  margin: 0 -10px;
}

.subscription-col {
  padding: 10px;
}
.sub-right
{
  font-size:22px;
}
.card-icon
{
  width:50px;
  height:40px;
  border-radius:5px;
  background:#f1f1f1;
  display:flex;
  justify-content: center;
  align-items: center;
  padding:5px;
 
}
.pastille-current
{
  background-color: #fff;

  padding:5px 10px;
  border-radius:5px;
  font-size:12px;
  color:#000;
  position: absolute;
  top:20px;
  right:10px;
}
.sub-left
{
  display:flex;
  
  align-items: flex-start;
  gap:10px;
}
.sub-left img
{
 position:relative;
 top:4px;
}
.sub-item-big
{
  flex-direction: column;
  background:#f1f1f1;
  padding:15px;
  gap:10px;
  border-radius:5px;
  display:flex;
  justify-content: space-between;
  align-items: flex-start;
}
.sub-item
{
  background:#f1f1f1;
  padding:10px;
  border-radius:5px;
  display:flex;
  justify-content: space-between;
  align-items: flex-start;
}
.active-subscription .sub-item,.active-subscription .sub-item-big
{
  background-color: #fff !important;
}
.active-subscription
{
  background-color: #f1f1f1 !important;
}
</style>
